import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { DataService } from '../../../core/service/base/data.service';
import { Observable } from 'rxjs';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { BrfTransferListItem } from '../../model/Transfer/brftransfer-list-item';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { CooperativeHousingShareTransaction } from '../../model/Transfer/cooperative-housing-share-transaction';
import { PreTransferActionModel } from '../../model/Transfer/pre-transfer-action-model';

@Injectable()
export class CooperativeHousingTransferService extends DataService<BrfTransferListItem> {
  private readonly _defaultFilterFields: string[] = ['incomeYear', 'companyId', 'rentalId', 'sellerContactName'];

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, BrfTransferListItem, progressBar, 'brf-transfer');
  }

  getObjectTransactions(objectId: string): Observable<CooperativeHousingShareTransaction[]> {
    return this.client.get<any[]>(`${this.endpoint}/objectTransactions/${objectId}`).pipe(
      map(arr => arr.map(res => new CooperativeHousingShareTransaction(res))),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }

  getPreTransferDefaults(leaseAgreementId: string): Observable<PreTransferActionModel> {
    this.progressBar.start();
    return this.client
      .get<PreTransferActionModel>(`${this.endpoint}/pre-transfer/${leaseAgreementId}`)
      .pipe(finalize(() => this.progressBar.stop()));
  }

  createPreTransfer(context: PreTransferActionModel): Observable<any> {
    this.progressBar.start();
    return this.client.post<any>(`${this.endpoint}/pre-transfer`, JSON.stringify(context)).pipe(
      tap(() => {
        this.notification.showSuccess();
      }),
      catchError(e => {
        this.notification.showError(e);
        throw e;
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  getFilterDefinition(): Observable<{
    incomeYear: number;
    companyId: string;
    rentalId: string;
    sellerContactName: string;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client.get<any>(`${this.endpoint}/filter`).pipe(
      map(res => {
        return {
          incomeYear: res.incomeYear ? res.incomeYear : '',
          companyId: res.companyId ? res.companyId : null,
          rentalId: res.rentalId ? res.rentalId : '',
          sellerContactName: res.sellerContactName ? res.sellerContactName : '',
          selectedFields: Array.isArray(res.selectedFields) && res.selectedFields.length ? res.selectedFields : this._defaultFilterFields,
          defaultFields: this._defaultFilterFields,
        };
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }
}
